import React, { PureComponent } from 'react';
import Icon from 'Common/Icon';
import { getActiveFilterButtontext } from 'Common/formValues';
import styles from 'components/FilterForm.scss';
import { withRouter } from 'react-router-dom';

class ActiveFilters extends PureComponent<*, *> {
  constructor(props) {
    super(props);
    this.state = {
      showAllFilters: false
    };
    this.handleMoreFiltersClick = this.handleMoreFiltersClick.bind(this);
  }

  handleMoreFiltersClick() {
    this.setState({ showAllFilters: !this.state.showAllFilters });
  }

  render() {
    const {
      fields,
      dealerName,
      activeFilters,
      removeActiveFilter,
      resetAllFields,
      isMobile
    } = this.props;

    const urlParams = new URLSearchParams(this.props.location.search);
    let nearlyNewDeals = false;
    if (urlParams.get('minPlate') || urlParams.get('maxPlate')) {
      nearlyNewDeals = true;
    }

    return (
      <div>
        {(activeFilters.length >= 1 || nearlyNewDeals) && (
          <div className={styles.activeFilters}>
            <div className={styles.activeFiltersHeading}>
              <div className={styles.activeFiltersTextContainer}>
                {isMobile && (
                  <div>
                    <span className={styles.filterCountText}>
                      Chosen Filters{' '}
                    </span>
                    <span className={styles.filterCount}>
                      (
                      {nearlyNewDeals
                        ? activeFilters.length + 1
                        : activeFilters.length}
                      )
                    </span>
                  </div>
                )}
                {isMobile && (
                  <button
                    className={styles.activeFilterClearButton}
                    onClick={resetAllFields}
                  >
                    Clear all
                  </button>
                )}
              </div>
              <div className={styles.activeFiltersContainer}>
                {!isMobile && (
                  <div className={styles.filterCountBox}>
                    <span className={styles.filterCountText}>
                      Chosen Filters{' '}
                    </span>
                    <span className={styles.filterCount}>
                      (
                      {nearlyNewDeals
                        ? activeFilters.length + 1
                        : activeFilters.length}
                      )
                    </span>
                  </div>
                )}
                {(!isMobile || this.state.showAllFilters
                  ? activeFilters
                  : activeFilters.slice(0, nearlyNewDeals ? 4 : 5)
                ).map(key => (
                  <button
                    className={styles.activeFilterButton}
                    onClick={() => removeActiveFilter(key)}
                    key={key}
                  >
                    {typeof fields[key] === 'boolean' && fields[key] && key}
                    {getActiveFilterButtontext(fields, key, dealerName)}
                    <Icon
                      iconName={'close'}
                      size={'small'}
                      className={styles.activeFilterIcon}
                    />
                  </button>
                ))}
                {nearlyNewDeals ? (
                  <button
                    className={styles.activeFilterButton}
                    onClick={() => removeActiveFilter('nearlyNewDeals')}
                    key={'nearlyNewDeals'}
                  >
                    {'Nearly new deals'}
                    <Icon
                      iconName={'close'}
                      size={'small'}
                      className={styles.activeFilterIcon}
                    />
                  </button>
                ) : (
                  ''
                )}
                {!isMobile && (
                  <button
                    className={styles.activeFilterClearButton}
                    onClick={resetAllFields}
                  >
                    Clear all
                  </button>
                )}
              </div>
              {isMobile && activeFilters.length > (nearlyNewDeals ? 4 : 5) && (
                <div
                  className={styles.moreFiltersContainer}
                  onClick={this.handleMoreFiltersClick}
                >
                  <span className={styles.moreFiltersLine}></span>
                  <span className={styles.moreFiltersText}>
                    {this.state.showAllFilters
                      ? 'Show less applied filters'
                      : 'See all applied filters'}
                  </span>
                  <span className={styles.moreFiltersLine}></span>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(ActiveFilters);



// WEBPACK FOOTER //
// ./src/Results/ActiveFilters/index.js